/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useMemo } from 'react';

import { useIsDesktop } from '@/hooks/useIsDesktop';
import { EnumCoverGoldDate } from '@/types/minileagues';

type PropsCover = {
  context?: EnumCoverGoldDate;
  caption?: string | JSX.Element;
};
export const CoverImageGoldDate = React.memo(
  ({ context = EnumCoverGoldDate.Default, caption }: PropsCover) => {
    const { isMobile } = useIsDesktop();

    const background = useMemo(() => {
      return [EnumCoverGoldDate.Default].includes(context)
        ? `/assets/images/bg_goldDate-cover-default${isMobile ? '-xs' : ''}.jpg`
        : `/assets/images/bg_goldDate-cover-final${isMobile ? '-xs' : ''}.jpg`;
    }, [context, isMobile]);

    return (
      <figure
        className="mt-4 h-[83px] lg:bg-center lg:h-[142px] w-full rounded-xl bg-cover flex lg:justify-center items-center"
        style={{ backgroundImage: `url(${background})` }}
      >
        <figcaption className="text-white uppercase font-bebas font-[100] lg:font-[100] lg:text-3xl text-2xl pl-5">
          {caption}
        </figcaption>
      </figure>
    );
  }
);

CoverImageGoldDate.displayName = 'CoverImageGoldDate';
